const state = {
  routerList: [],
  isBackClick: false
};

const mutations = {
  INSERTROUTE(state, name) {
    if (state.routerList.indexOf(name) > -1) {
    } else {
      state.routerList.push(name);
    }
  },
  DELETEROUTE(state, obj) {
    state.routerList.pop();
  },
  ISCLCIK(state, boolean) {
    state.isBackClick = boolean;
  }
};

const actions = {
  insertRoute(context, obj) {
    context.commit("INSERTROUTE", obj);
  },
  deleteRoute(context, obj) {
    context.commit("DELETEROUTE");
  },
  isGoBack(context, boolean) {
    context.commit("ISCLCIK", boolean);
  }
};

const getters = {
  routerList: state => state.routerList,
  isBackClick: state => state.isBackClick
};

export default {
  state,
  mutations,
  actions,
  getters
};
